import PropTypes from 'prop-types';
import React from 'react';
import { Select } from 'antd';

import { ConsentGatePreferences as ConsentRecord } from './scenario_records_2.js';

const Option = Select.Option;

class ConsentGatePreferences extends React.Component {
  static propTypes = {
    editing: PropTypes.bool.isRequired,
    data: PropTypes.instanceOf(ConsentRecord).isRequired,
    onChange: PropTypes.func.isRequired,
  }

  handleChangeSatisfy = (continueOnSatisfy) => {
    let data = this.props.data.set('status', continueOnSatisfy);
    this.props.onChange(data);
  }

  static statuses = [
    { value: 0, label: 'No Action' },
    { value: 7, label: 'Configuration Additions' },
  ];

  render() {
    const continueOnSatisfy = ConsentGatePreferences.statuses
        .filter(status => status.value === this.props.data.status)
        .map(status => status.label)[0];
debugger
    const options = ConsentGatePreferences.statuses.map(
      status => <Option key={ status.value } value={ status.value }>{ status.label }</Option>);

    if (!this.props.editing) {
      return (
        <div>
          Consent (Preferences): { continueOnSatisfy }
        </div>
      );
    } else {
      return (
        <div className="step-block-editing">
          { this.props.children }
          <Select
            onChange={ this.handleChangeSatisfy }
            value={ this.props.data.status }
          >
            { options }
          </Select>
        </div>
      );
    }
  }
}

export default ConsentGatePreferences;
